/** Resource da API das Análises de Mercados */
export const CLIENTES_ANALISES_MERCADOS_API_RESOURCE = 'clienteanalisemercado';
